import { render } from "./studentReview.vue?vue&type=template&id=f09ec99c&scoped=true"
import script from "./studentReview.vue?vue&type=script&lang=js"
export * from "./studentReview.vue?vue&type=script&lang=js"

import "./studentReview.vue?vue&type=style&index=0&id=f09ec99c&lang=scss&scoped=true"

import exportComponent from "/Volumes/work/mywork/selecthouse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f09ec99c"]])

export default __exports__